import { useEffect, useRef, useState } from 'react'
import Header from 'components/Header/Header'
import './style.css'
import First from 'components/MainMo/Fisrt'
import Second from 'components/MainMo/Second'
import Third from 'components/MainMo/Third'
import Fourth from 'components/MainMo/Fourth'
import Team from 'components/MainMo/Team'
import useIntersectionObserver from 'hook/useIntersectionObserver'

const MainMo = () => {
  const [isWhite, setIsWhite] = useState(false);
  const changeRef = useRef<any>(null);

  useEffect(() => {
    changeRef.current = document.getElementById('Change') as HTMLElement;
  }, [])

  useIntersectionObserver({
    target: changeRef,
    threshold: 0.23,
    enabled: true,
    onIntersect: () => setIsWhite(true),
    offIntersect: () => setIsWhite(false),
  });

  return (
    <>
      <Header bgWhite={isWhite} isWhite={false} isOverLay={isWhite} />
      <First />
      <Second />
      <Fourth />
      <div id='Change'>
        <Third />
        <Team />
      </div>
    </>
  )
}

export default MainMo
